/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const createAboutPageStyles = makeStyles(() =>
  createStyles({
    root: {
      minHeight: '100vh',
    },
  }),
);

export { createAboutPageStyles };
